import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { useEffect, useMemo, useState } from 'react';
import { getFrequencyQuestions } from './../api/routes';

export default function FrequencyQuestions() {
  const [expanded, setExpanded] = useState(false);
  const [FQs, setFQs] = useState([]);

  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    getFrequencyQuestions((isOk, data) => {
      if (!isOk) return alert(data.message);
      setFQs(data || []);
    })
  }, []);

  const accSx = useMemo(() => ({
    background: 'rgba(255,255,255,0.70)',
    borderRadius: '18px',
    border: '1px solid rgba(255,255,255,0.60)',
    backdropFilter: 'blur(14px)',
    boxShadow: '0 22px 80px rgba(2,132,199,0.10)',
    marginTop: '14px',
    overflow: 'hidden',
    '&:before': { display: 'none' },
    '& .MuiAccordionSummary-root': {
      minHeight: '64px',
      paddingInline: '16px',
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      gap: '10px',
      alignItems: 'center',
    },
    '& .MuiAccordionDetails-root': {
      padding: '0 16px 16px 16px',
    },
  }), []);

  return (
    <div className="relative overflow-hidden py-24" id="faq">
      <div className="container mx-auto px-4">
        <div className="w-full lg:w-[92%] mx-auto">

          {/* heading */}
          <section className="flex flex-col items-center">
            <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-md">
              سوالات متداول
            </span>

            <h2 className="mt-5 text-center text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">
              پرسش‌های رایج مراجعین
            </h2>

            <div className="mt-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6]" />

            <p className="text-center text-sm sm:text-base mt-6 text-slate-600 max-w-2xl leading-7">
              پاسخ‌های کوتاه و شفاف به سوالات پرتکرار درباره خدمات تصویربرداری، نوبت‌دهی و آماده‌سازی قبل از مراجعه.
            </p>
          </section>

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Accordions */}
            <section className="w-full">
              {FQs.map((fq, index) => (
                <Accordion
                  key={fq.frequencyQuestionsId}
                  expanded={expanded === `panel${index}`}
                  onChange={handleChange(`panel${index}`)}
                  sx={accSx}
                >
                  <AccordionSummary
                    expandIcon={
                      <span className="w-10 h-10 rounded-2xl bg-[#e8fbff] ring-1 ring-[#bfefff] grid place-items-center">
                        <span className="text-[#0284c7] text-sm">⌄</span>
                      </span>
                    }
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-2.5 h-2.5 rounded-full bg-[#06b6d4]" />
                      <p className="text-sm sm:text-base font-extrabold text-slate-900">
                        {fq.question}
                      </p>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <p className="text-sm sm:text-base text-slate-600 leading-7 text-justify">
                      {fq.answer}
                    </p>
                  </AccordionDetails>

                  {/* bottom accent */}
                  <div className="h-[2px] w-full bg-gradient-to-r from-[#06b6d4] via-[#22c55e] to-[#3b82f6] opacity-35" />
                </Accordion>
              ))}

              {(!FQs || FQs.length === 0) && (
                <div className="mt-10 text-center text-slate-600">
                  فعلاً سوالی ثبت نشده است.
                </div>
              )}
            </section>

            {/* Image (styled) */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative w-[95%] sm:w-[520px]">
                  <img
                    loading="lazy"
                    src="/assets/images/faq.png"
                    alt="faq"
                    className="w-full h-[360px] sm:h-[420px] object-contain"
                  />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
